import { render, staticRenderFns } from "./pageContent.vue?vue&type=template&id=61bc9898&"
import script from "./pageContent.vue?vue&type=script&lang=js&"
export * from "./pageContent.vue?vue&type=script&lang=js&"
import style0 from "./pageContent.vue?vue&type=style&index=0&id=61bc9898&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports